<template>
    <div class="register-view">
        <veui-alert class="limit-width"
            type="success"
            message="如果您已有锦囊账号，欢迎使用锦囊账号直接登录开放平台。点击使用"/>
        <div class="veui-alert veui-alert-success link"><veui-link to="/">锦囊账号登录</veui-link></div>

        <veui-form class="register-form"
            ref="form"
            v-bind="formSetting"
            :data="formData"
            @submit="handleSubmit">
            <veui-field field="userName" name="userName" label="用户名：" :rules="userNameRules">
                <veui-input v-model="formData.userName"/>
            </veui-field>
            <veui-field field="contact" name="contact" label="联系人姓名：" :rules="contactRules">
                <veui-input v-model="formData.contact"/>
            </veui-field>
            <veui-field field="email" name="email" label="联系人邮箱：" rules="required">
                <veui-input v-model="formData.email"/>
            </veui-field>
            <veui-field field="phone" name="phone" label="联系人电话：" :rules="[{name: 'required', triggers: 'input'}]">
                <veui-input v-model="formData.phone"/>
                <veui-button @click="sendSmsCode" :disabled="inValidPhone">发送验证码</veui-button>
            </veui-field>
            <veui-field field="smscode" name="smscode" label="短信验证码：" rules="required">
                <veui-input v-model="formData.smscode"/>
            </veui-field>
            <veui-field field="password" name="password" label="密码：" rules="required">
                <veui-input v-model="formData.password" type="password"/>
            </veui-field>
            <veui-field field="password2" name="password2" label="再次输入密码：" rules="required">
                <veui-input v-model="formData.password2" type="password"/>
            </veui-field>

            <div class="form-operation">
                <veui-button ui="primary" type="submit">提交</veui-button>
                <veui-button @click="back">取消</veui-button>
            </div>
        </veui-form>

        <veui-overlay :open.sync="isLoading"
            overlay-class="global-loading"
            :priority="99999">
            <div class="loading-icon" v-once><loading></loading></div>
        </veui-overlay>
    </div>
</template>

<script>
import api from '@/common/system/api';
import Nmp from '@baidu/ve-ria/io/Nmp';
import patterns from '@/common/utils/patterns';
import alertManager from 'veui/managers/alert';
import Loading from '@baidu/ve-ria/components/Loading';
import {Alert, Form, Field, Input, Button, Link, Overlay} from 'veui';

let nmp = new Nmp();
export default {
    name: 'register-view',
    components: {
        'veui-overlay': Overlay,
        'veui-alert': Alert,
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-input': Input,
        'veui-link': Link,
        Loading
    },
    data() {
        return {
            formData: {
                userName: '',
                contact: '',
                email: '',
                phone: '',
                smscode: '',
                password: '',
                password2: ''
            },
            formSetting: {
                // 表单字段验证
                validators: [
                    {
                        fields: ['userName'],
                        handler: val => {
                            if (patterns.name.test(val)) {
                                return true;
                            }
                            return {userName: '请输入数字，字母或汉字'};
                        }
                    },
                    {
                        fields: ['contact'],
                        handler: val => {
                            if (patterns.name.test(val)) {
                                return true;
                            }
                            return {contact: '请输入数字，字母或汉字'};
                        }
                    },
                    {
                        fields: ['email'],
                        handler: val => {
                            if (patterns.mail.test(val)) {
                                return true;
                            }
                            return {email: '请输入正确的邮箱地址'};
                        }
                    },
                    {
                        fields: ['phone'],
                        validate: val => {
                            this.inValidPhone = true;
                            if (patterns.phone.test(val)) {
                                this.inValidPhone = false;
                                return true;
                            }
                            return {phone: '请输入正确的11位手机号码'};
                        },
                        triggers: 'input'
                    },
                    {
                        fields: ['smscode'],
                        handler: val => {
                            if (patterns.smscode.test(val)) {
                                return true;
                            }
                            return {smscode: '请输入收到的4位短信验证码'};
                        }
                    },
                    {
                        fields: ['password'],
                        handler: val => {
                            if (patterns.password.test(val)) {
                                return true;
                            }
                            return {password: '请输入包含数字、大、小写字母，长度6到32位'};
                        }
                    },
                    {
                        fields: ['password2'],
                        handler: val => {
                            if (val === this.formData.password) {
                                return true;
                            }
                            return {password2: '两次输入的密码不一致'};
                        }
                    }
                ],
                afterValidate: () => {
                    // 检验是否发送过短信验证码
                    if (!this.transId) {
                        alertManager.warn('请先发送短信验证码', '提示');
                        return false;
                    }

                    return true;
                }
            },
            userNameRules: [
                {name: 'required'},
                this.maxLenRule(32),
                {
                    name: 'minLength',
                    value: 6,
                    message: '名称长度不得低于6个字符',
                    triggers: 'input'
                }
            ],
            contactRules: [
                {name: 'required'},
                this.maxLenRule(20)
            ],
            isLoading: false,
            transId: null,
            inValidPhone: true
        };
    },
    created() {
        this.smsCodeSendRequester = this.genRequester(api.smsCodeSend);
        this.registerRequester = this.genRequester(api.register);
    },
    methods: {
        back() {
            this.$router.back();
        },
        maxLenRule(len) {
            return {
                name: 'maxLength',
                value: len,
                message: `名称长度不得超过${len}个字`
            };
        },
        handleInvalid(err) {
            this.handleErrorScroll(Object.keys(err));
        },
        async sendSmsCode() {
            let data = await this.smsCodeSendRequester({phone: this.formData.phone});
            this.transId = data.transId;
        },
        async handleSubmit(data) {
            data.smscodeTransId = this.transId;
            delete data.password2;
            this.isLoading = true;
            await this.registerRequester(data);
            this.handleSuccess();
        },
        handleSuccess() {
            this.$refs.form.fields.forEach(field => field.hideValidity());
            alertManager.success(
                '恭喜您已完成服务商开放平台账号注册！',
                '系统提示',
                {ok: () => {
                    this.$router.push('/');
                }}
            );
        },
        genRequester(url) {
            let requester = nmp.genRequesters(url);
            return async data => {
                let result;
                try {
                    this.isLoading = true;
                    result = await requester(data);
                }
                catch (e) {
                    throw e;
                }
                finally {
                    this.isLoading = false;
                }
                return result;
            };
        }
    }
};
</script>

<style lang="less">
@import '~veui-theme-one/variables.less';
.register-view {
    height: 100%;
    margin: 30px 50px;
    padding-left: 120px;
    background: #fff;
    .veui-alert {
        display: inline;
        &.limit-width {
            width: 450px;
        }
        > div {
            display: inline;
        }
        &.link {
            margin-left: -10px;
            padding-left: 0;
        }
    }

    .register-form {
        margin-top: 30px;
        .veui-field .veui-form-label {
            width: @veui-width-embed;
        }
        .form-operation {
            margin-left: @veui-width-embed;
            .veui-button {
                margin-right: 30px;
            }
        }
    }
}
.global-loading {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(63, 63, 63, .6);
    text-align: center;
    color: #fff;
    padding-top: 200px;

    .loading-icon {
        width: 100px;
        height: 100px;
        padding: 10px;
        box-sizing: border-box;
        margin: auto;
        background: rgba(0, 0, 0, .7);
        border-radius: 4px;
    }
}
</style>
